import { initialAction, initialState } from './initial';

type Reducer = (
  state: typeof initialState,
  action: typeof initialAction,
) => typeof initialState;

const reducer: Reducer = (state, action) => {
  const { type, payload } = action ?? {};

  switch (type) {
    case 'UPDATE_CATEGORY_ICON':
    case 'UPDATE_CATEGORY_TITLE':
    case 'UPDATE_CATEGORY_PARENT':
    case 'UPDATE_CATEGORY_RELATED_ATTRIBUTE':
    case 'UPDATE_CATEGORY_SUB_SLUG':
    case 'UPDATE_CATEGORY_DESCRIPTION':
    case 'UPDATE_CATEGORY_SEO':
    case 'UPDATE_CATEGORY_CATALOG_BRAND':
    case 'UPDATE_CATEGORY_TAGS':
    case 'UPDATE_CATEGORY_STEP': {
      return {
        ...state,
        ...payload,
      };
    }
    default: {
      return state;
    }
  }
};

export { reducer };
